import {Typography} from '@mui/material'

type Props = {
  stoppageCode: string | undefined
  stoppageDescription: string | undefined
}

export const RunningTimeStoppageLabel = ({stoppageCode, stoppageDescription}: Props) => {
  if (!stoppageCode) {
    return null
  }

  return (
    <Typography variant="h5">
      {stoppageCode}
      {stoppageDescription && ` - ${stoppageDescription}`}
    </Typography>
  )
}
